"use strict";
const searchFormSelector = '.js-search_form';
const searchInputSelector = '.js-search_input';
const searchInputClearSelector = '.js-search_input_clear';
const spinnerSelector = '.js-search_input_loader';
const searchIconSelector = '.js-search_input_default_icon';
window.up.compiler(searchFormSelector, function (form) {
    window.up.on(form, 'up:form:submit', undefined, () => {
        const spinner = form.querySelector(spinnerSelector);
        const searchIcon = form.querySelector(searchIconSelector);
        spinner === null || spinner === void 0 ? void 0 : spinner.classList.remove('hide');
        searchIcon === null || searchIcon === void 0 ? void 0 : searchIcon.classList.add('hide');
    });
});
window.up.compiler('.js-search_target', function () {
    const spinner = document.querySelector(spinnerSelector);
    const searchIcon = document.querySelector(searchIconSelector);
    spinner === null || spinner === void 0 ? void 0 : spinner.classList.add('hide');
    searchIcon === null || searchIcon === void 0 ? void 0 : searchIcon.classList.remove('hide');
});
window.up.compiler(searchInputSelector, input => window.up.on(input, 'input', undefined, (ev) => {
    const clear = document.querySelector(searchInputClearSelector);
    ev.target.value === '' ? clear === null || clear === void 0 ? void 0 : clear.classList.add('hide') : clear === null || clear === void 0 ? void 0 : clear.classList.remove('hide');
}));
window.up.compiler(searchInputClearSelector, clear => {
    window.up.on(clear, 'click', undefined, () => {
        const input = document.querySelector(searchInputSelector);
        if (input) {
            input.value = '';
            input.dispatchEvent(new Event('change'));
            input.dispatchEvent(new Event('input'));
        }
        clear.classList.add('hide');
        window.up.submit(searchFormSelector);
    });
});
